const capitalize = word => (word) ? `${word.charAt(0).toUpperCase()}${word.substring(1)}` : '';

export default capitalize;